// The site's provider: where a visit keeps a person's files and settings, chosen once here, and every page's disks
// and settings from it, the package's provider (@moonbase-machines/player/provider.js) given what is the site's: the
// backend (signed in, the account's, the site's API's, web/disk/api.js, so a save and a setting follow the person
// from browser to browser; signed out, this browser's, IndexedDB, as ever; /api/me asked once, and where there is
// none, the preview served as plain files, this browser's), a setting's value
// for the visit from the page's address (web/address.js: ?old-style, ?sound=off), and the build's policy of what a
// page offers. A play page passes the title's disk and the settings to play() (tools/site.mjs); a program that saves
// opens its disks here (the BASIC editor, Microsoft BASIC, the game document); a page's own choices are settings here
// too (the Island's). The player and the programs never choose.
//
//   const { disk, settings } = await provider({ hidden })   hidden: the settings this build does not offer
//   await disk(name)                                       a disk by its name: titleDisk(slug), programDisk(name)
//   settings                                               the person's settings, the typed store (settings.js)
import { provider as make } from '@moonbase-machines/player/provider.js';
import { visit } from './address.js';
import { api } from './disk/api.js';

// (who is signed in, if the site has accounts: { account, ... }, or null)
export async function whoAmI() {
  try { const r = await fetch('/api/me', { cache: 'no-store' }); return r.ok ? await r.json() : null; } catch { return null; }
}
let made = null;
export function provider({ hidden = [] } = {}) {
  return made ??= whoAmI().then(me => make({ backend: me?.account ? api() : undefined, visit, hidden }));
}
